import supportEn from './en/en.json'
import supportAr from './ar/ar.json'
import supportEs from './es/es.json'
import supportDe from './de/de.json'
import supportIt from './it/it.json'
import supportFr from './fr/fr.json'
import supportPt from './pt/pt.json'
import supportEl from './el/el.json'
import supportBn from './bn/bn.json'
import supportSr from './sr/sr.json'
import supportCs from './cs/cs.json'
import supportPl from './pl/pl.json'
import supportHu from './hu/hu.json'
import supportSk from './sk/sk.json'
import supportRo from './ro/ro.json'
import supportBg from './bg/bg.json'
import supportMk from './mk/mk.json'
import supportSq from './sq/sq.json'

const SupportMessages = {
  en: { support: { ...supportEn } },
  ar: { support: { ...supportAr } },
  es: { support: { ...supportEs } },
  de: { support: { ...supportDe } },
  it: { support: { ...supportIt } },
  fr: { support: { ...supportFr } },
  pt: { support: { ...supportPt } },
  el: { support: { ...supportEl } },
  bn: { support: { ...supportBn } },
  sr: { support: { ...supportSr } },
  cs: { support: { ...supportCs } },
  pl: { support: { ...supportPl } },
  hu: { support: { ...supportHu } },
  sk: { support: { ...supportSk } },
  ro: { support: { ...supportRo } },
  bg: { support: { ...supportBg } },
  mk: { support: { ...supportMk } },
  sq: { support: { ...supportSq } },
}

export default SupportMessages
